module.exports = __webpack_public_path__ + "static/img/group.0f23ee55.png";